import React from 'react';
import PropTypes from 'prop-types';
import { useVartanaFeatureFlags } from '../../../../utils/helpers';
import ActivitiesCard from '../../../../components/ActivitiesCard/ActivitiesCard';

function TrackRecipients({ emailHistory, canCopyLink }) {
  const { vendorCheckoutUrl: showVendorCheckoutUrl } = useVartanaFeatureFlags();
  return (
    <div className="space-y-4">
      <ActivitiesCard
        emailHistory={emailHistory}
        showVendorCheckoutUrl={showVendorCheckoutUrl}
        canCopyLink={canCopyLink}
      />
    </div>
  );
}

TrackRecipients.propTypes = {
  emailHistory: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      events: PropTypes.arrayOf(PropTypes.shape({})),
      url: PropTypes.string,
    })
  ),
  canCopyLink: PropTypes.bool,
};

TrackRecipients.defaultProps = {
  emailHistory: [],
  canCopyLink: false,
};

export default TrackRecipients;
